import "./cabq.css";
import registry from "@patternslib/patternslib/src/core/registry";
import "./cabqtabs/cabqtabs";
import "./markspeciallinks/markspeciallinks";
import "./gallerymasonry/gallerymasonry";

registry.init();

// Add Google Translate widget
window.googleTranslateElementInit = function googleTranslateElementInit() {
    var $window = $(window);
    var viewportWidth = $window.width();
    var $translateEl = $("#google_translate_element");
    if (viewportWidth < 1200) {
      $translateEl.appendTo(".siteTranslateMobile");
    } else {
      $translateEl.appendTo(".siteTranslate");
    }

    new google.translate.TranslateElement({
        pageLanguage: 'en',
        // layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
        gaTrack: true,
        gaId: 'UA-86004-1'
    }, 'google_translate_element');

    // #1696920: Remove style property from body
    $('body').attr('style', '');
}

function handleTabFocusModal(modal, prevFocused, firstElem, lastElem, startFocused) {
    // Trap focus within modal div
    const KEYCODE_TAB = 9;
    const KEYCODE_ESC = 27;

    modal.keydown(function(e) {

        // set last focus if esc key pressed
        if(e.keyCode === KEYCODE_ESC) {
            e.preventDefault();
            modal.modal('hide');
        }

        // return everything else
        else if (e.keyCode !== KEYCODE_TAB) {
          return;
        }

        if ( e.shiftKey ) /* shift + tab */ {
            if (firstElem.is(':focus')) {
              lastElem.focus();
              e.preventDefault();
            }
        } else /* tab */ {
            if (lastElem.is(':focus')) {
              firstElem.focus();
              e.preventDefault();
            }
        }
    });

    modal.modal('show');

    // Get the current focused element:
    modal.on('shown.bs.modal', function () {
      if (startFocused !== undefined){
        startFocused.focus(); // if startFocused provided, focus on it
      } else {
        firstElem.focus(); //force focus on first element
      }
    })

    modal.on('hidden.bs.modal', function () {
      prevFocused.focus(); //force focus on button that opened the modal
    })
}

$(window.document).on('click', 'a.translateButton', function(event) {
    event.preventDefault();

    const modal = $('#translatePopup');
    // grab the current focused element so we can set it back when modal is closed
    var prevFocused = $(document.activeElement);
    var firstElem = $("button.close", modal);

    // close modal if close is clicked
    modal.on('click', 'button.close', function(event) {
      event.preventDefault();
      modal.modal('hide');
    });

    modal.on('click', 'button.close-modal', function(event) {
      event.preventDefault();
      modal.modal('hide');
    });

    var lastElem = $("button.btn:last", modal);
    handleTabFocusModal(modal, prevFocused, firstElem, lastElem);

});

$(window.document).on('click', 'a.siteSearchButton', function(event) {
    event.preventDefault();

    const modal = $('#searchModal');
    // grab the current focused element so we can set it back when modal is closed
    var prevFocused = $(document.activeElement);
    var firstElem = $("button.close", modal);

    // close modal if close is clicked
    modal.on('click', 'button.close', function(event) {
      event.preventDefault();
      modal.modal('hide');
    });

    modal.on('click', 'button.close-modal', function(event) {
      event.preventDefault();
      modal.modal('hide');
    });

    var lastElem = $("button.btn:last", modal);
    var searchInput = $("input#siteSearchInput", modal);
    handleTabFocusModal(modal, prevFocused, firstElem, lastElem, searchInput);
});

$(function () {
    var $panelHeadings = $(".panel-default .panel-heading");
    if (!$panelHeadings.length) {
      return;
    }
    $panelHeadings.click(function (e) {
      e.preventDefault();
      $panelHeadings.removeClass("active");
      $(this).addClass("active");
    });
});

$(function () {
    var resizeTimer;
    var $window = $(window);
    $window.on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
        var viewportWidth = $window.width();
        var $translateEl = $("#google_translate_element");
        if (viewportWidth < 1200) {
            $translateEl.appendTo(".siteTranslateMobile");
        } else {
            $translateEl.appendTo(".siteTranslate");
        }
        }, 200);
    });
});

const navbarHeight = 130;
const navFudgeFactor = 2;
//#region page initialization
$(document).ready(function () {
  initializeNavbarPlacement("#navbar-large", "#hero");
  initializeRightnavPlacement("#rightnav", "#hero");
  if ($('.mosaic-width-full #hero').hasClass('cabq-hero') ) {
      $('#wrap').addClass('full-hero');
    }
});
/**
 * setup for localStorage/sessionStorage
 *
 * localStorage.accessibilityColors: accessiblility colors use for website
 *
 */
/**
 * initialize DOM tree with Web Storage States
 *
 * e.g. saved user setting such as:
 *  - browsing preference
 *  - disabliltiy colors on/off
 */

/**
 * set #navbar initial CSS display position, depending on existance of Hero Page
 *  1. if Hero page Exist: on bottom
 *  2. if Hero page NOT Exist: on top
 *
 * @param string navbarElementID for placement
 * @param string heroElementID to check existence
 */
function initializeNavbarPlacement (navbarElementID, heroElementID) {
  let classToAdd = () => {return ($(heroElementID).length == 0) ? 'fix-top' : 'fix-bottom';};
  let classToRemove = () => {return ($(heroElementID).length == 1) ? 'fix-top' : 'fix-bottom';};
  $(navbarElementID)
    .addClass(classToAdd())
    .removeClass(classToRemove());
}
/**
 *  set #rightnav initial CSS display position, depending on existance of Hero Page
 *   1. if Hero Page Exist: (do not assign a display position)
 *   1. if Hero Page NOT Exist: (assign class="fix-right" for display!)
 *
 * @param string rightnavElementID
 * @param string heroElementID
 */
function initializeRightnavPlacement (rightnavElementID, heroElementID) {
  if ($(heroElementID).length == 1){
    $(rightnavElementID).removeClass('fix-right');
  } else {
    $(rightnavElementID).addClass('fix-right');
  }
}
//#endregion


/**
 * Swap all indicator icons for accessibility button
 * 1. all indicator icon <img> tags can be found if they are labled with class="accessibilityIndicatorIcon"
 * 2. alt image src should be identified within the HTML <img> tag in data-* field
 *
 * @param {*} srcPropertyField
 */


//#region UX: [#navbar #navbar-mini] mobile drop down show and hide based on clicking
function dropdownMenu(dropdownElementID){
  let dropdown_el = document.getElementById(dropdownElementID);
  if(dropdown_el){
    document.getElementById(dropdownElementID).classList.toggle("show");
  }else {
    throw new Error("no element with ID: " + dropdownElementID);
  }
}
// hide dropdown when scrolling
// var prevScrollpos = window.pageYOffset;
// window.onscroll = function() {
//   var currentScrollPos = window.pageYOffset;
//   if (prevScrollpos != currentScrollPos) {
//     document.getElementById("mobile-dropdown").classList.remove("show");
//   }
//   prevScrollpos = currentScrollPos;
// }
//#endregion

$(window.document).on('click', 'button#mobile-menu-button', function (event){
  dropdownMenu('mobile-dropdown');
})